import { Box, Modal } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AddIntakeForm from "../forms/AddIntakeForm";
import AddReleaseOfInformationForm from "../forms/AddReleaseOfInformationForm";
import AddGeneralLiabilityForm from "../forms/AddGeneralLiabilityForm";
import AddInformedConsentForm from "../forms/AddInformedConsentForm";
import AddConfidentialityPolicy from "../forms/AddConfidentialityPolicy";
import AddPsychiatristServicesForm from "../forms/AddPsychiatristServicesForm";
import AddClientRights from "../forms/AddClientRights";
import AddAgressionControl from "../forms/AddAgressionControl";
import { format } from "date-fns";
import { collection, doc, getDoc, onSnapshot, query } from "firebase/firestore";
import { db } from "../../firebase";
import FormLine2Mobile from "../Lines/FormLine2Mobile";
import TitleIntakeMobile from "../Titles/TitleIntakeMobile";
import FormLine3Mobile from "../Lines/FormLine3Mobile";
import TitleMobile from "../Titles/TitleMobile";
import FormLineICMobile from "../Lines/FormLineICMobile";
import FormLinePSCMobile from "../Lines/FormLinePSCMobile";
import FormLineCRMobile from "../Lines/FormLineCRMobile";
import FormLineACPMobile from "../Lines/FormLineACPMobile";
import FormLineTitleMobile from "../Lines/FormLineTitleMobile";
import UpdloaderRoiMobile from "../Updloader/UpdloaderRoiMobile";
import FormLineCPMobile from "../Lines/FormLineCPMobile";
import FormLineRoiMobile from "../FormLineRoiMobile";
import AddButtonRoundMobile from "../Buttons/AddButtonRoundMobile";
import FormLineDressCodeMobile from "../Lines/FormLineDressCodeMobile";
import AddDressCodeForm from "../forms/AddDressCodeForm";
import AddTreatmentEngagementForm from "../forms/AddTreatmentEngagementForm";
import FormLineTreatmentEngagementMobile from "../Lines/FormLineTreatmentEngagementMobile";
import UploaderAraEncapsulated from "../Updloader/UploaderAraEncapsulated";
import FormLinePoliticalViewsMobile from "../Lines/FormLinePoliticalViewsMobile";
import AddPoliticalViewsForm from "../forms/AddPoliticalViewsForm";
import AddAustralianSuperannuationForm from "../forms/AddAustralianSuperannuationForm";
import FormLineSuperAnnuationMobile from "../Lines/FormLineSuperAnnuationMobile";

import AddConsentAgreementUnsupervisedActivityGood from "../forms/AddConsentAgreementUnsupervisedActivityGood";
import AddClientOrientationChecklist from "../forms/AddClientOrientationChecklist";
import FormLineClientOrientationChecklistMobile from "../Lines/FormLineClientOrientationChecklistMobile";
import FormLineIntakeAndBagSearchCheclistMobile from "../Lines/FormLineIntakeAndBagSearchCheclistMobile";
import AddClientIntakeAndBagSearchChecklist from "../forms/AddClientIntakeAndBagSearchChecklist";

function FormsMobile(props) {

  const styleModalGeneral2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };


  const styleModalUploadPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "auto",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  // const { clientId } = props;

  const prevClientIdRef = useRef();

  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [clientDataRoi, setClientDataRoi] = useState([]);
  const [clientId, setClientId] = useState(props.clientId || "");
  const [openIntakeForm, setOpenIntakeForm] = useState(false);
  const [openRoiForm, setOpenRoiForm] = useState(false);
  const [openGeneralLiabilityForm, setOpenGeneralLiabilityForm] =
    useState(false);
  const [openInformedConsentForm, setOpenInformedConsentForm] = useState(false);
  const [openPsychiatricServicesForm, setOpenPsychiatricServicesForm] =
    useState(false);
  const [openConfidentialityPolicyForm, setOpenConfidentialityPolicyForm] =
    useState(false);
  const [
    openAustralianSuperAnnuationForm,
    setOpenAustralianSuperAnnuationForm,
  ] = useState(false);
  const [openIntakeForm2, setOpenIntakeForm2] = useState(false);
  const handleOpenAustralianSuperAnnuationForm = () =>
    setOpenAustralianSuperAnnuationForm(true);
  const handleCloseAustralianSuperAnnuationForm = () =>
    setOpenAustralianSuperAnnuationForm(false);
  const handleCloseIntakeForm2 = () => setOpenIntakeForm2(false);

  const [openClientRightsForm, setOpenClientRightsForm] = useState(false);
  const [openAgressionPolicyForm, setOpenAgressionPolicyForm] = useState(false);
  const [openUploadRoi, setOpenUploadRoi] = useState(false);
  const [openDressCodePolicy, setOpenDressCodePolicy] = useState(false);
  const [openTreatmentEngagment, setOpenTreatmentEngagment] = useState(false);
  const [openPoliticalViews, setOpenPoliticalViews] = useState(false);
  const handleOpenTreatmentEngagmentForm = () =>
    setOpenTreatmentEngagment(true);
  const handleCloseTreatmentEngagmentForm = () =>
    setOpenTreatmentEngagment(false);
  const handleOpenPoliticalViewsForm = () => setOpenPoliticalViews(true);
  const handleClosePoliticalViewsForm = () => setOpenPoliticalViews(false);
  const handleCloseUploadDoc = () => setOpenUploadRoi(false);
  const handleOpenIntakeForm = () => setOpenIntakeForm(true);
  const handleOpenRoiForm = () => setOpenRoiForm(true);
  const handleOpenGeneralLiabilityForm = () =>
    setOpenGeneralLiabilityForm(true);
  const handleOpenInformedConsentForm = () => setOpenInformedConsentForm(true);
  const handleOpenPsychiatricServicesForm = () =>
    setOpenPsychiatricServicesForm(true);
  const handleOpenConfidentialityPolicyForm = () =>
    setOpenConfidentialityPolicyForm(true);
  const handleOpenClientRightsForm = () => setOpenClientRightsForm(true);
  const handleOpenAgressionPolicyForm = () => setOpenAgressionPolicyForm(true);
  const handleOpenDressCodePolicyForm = () => setOpenDressCodePolicy(true);
  const handleCloseDressCodePolicyForm = () => setOpenDressCodePolicy(false);

  const handleCloseIntakeForm = () => setOpenIntakeForm(false);
  const handleCloseRoiForm = () => setOpenRoiForm(false);
  const handleCloseGeneralLiabilityForm = () =>
    setOpenGeneralLiabilityForm(false);
  const handleCloseInformedConsentForm = () =>
    setOpenInformedConsentForm(false);
  const handleClosePsychiatricServicesForm = () =>
    setOpenPsychiatricServicesForm(false);
  const handleCloseConfidentialityPolicyForm = () =>
    setOpenConfidentialityPolicyForm(false);
  const handleCloseClientRightsForm = () => setOpenClientRightsForm(false);
  const handleCloseAgressionPolicyForm = () =>
    setOpenAgressionPolicyForm(false);

  const [openClientOrientationChecklist, setopenClientOrientationChecklist] =
    useState(false);
  const handleOpenClientOrientationCheckList = () =>
    setopenClientOrientationChecklist(true);
  const handleCloseClientOrientationCheckList = () =>
    setopenClientOrientationChecklist(false);

  const [
    openClientIntakeAndBagSearchChecklist,
    setopenClientIntakeAndBagSearchChecklist,
  ] = useState(false);
  const handleOpenClientIntakeAndBagSearchChecklist = () =>
    setopenClientIntakeAndBagSearchChecklist(true);
  const handleCloseClientIntakeAndBagSearchChecklist = () =>
    setopenClientIntakeAndBagSearchChecklist(false);

  useEffect(() => {
    setClientId(props.clientId || "");
  }, [props.selectedTherapist]);

  useEffect(() => {
    setClientId(props.clientId || "");
  }, [props.clientId]);

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  useEffect(() => {}, [clientDataRoi]);

  useEffect(() => {
    let unsubscribe;

    const fetchData = async () => {
      try {
        const roiDocRef = doc(db, "roi", clientId);
        const roiDocSnap = await getDoc(roiDocRef);

        if (roiDocSnap.exists()) {
          const roiCollectionRef = collection(roiDocRef, "subcollection");

          // Utilisez onSnapshot pour écouter les modifications en temps réel
          unsubscribe = onSnapshot(
            roiCollectionRef,
            (roiCollectionSnapshot) => {
              if (roiCollectionSnapshot.empty) {
                // Si la sous-collection est vide, réinitialisez clientDataRoi à un tableau vide

                setClientDataRoi([]);
              } else {
                const data = roiCollectionSnapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                }));
                setClientDataRoi(data);
              }
            },
            (error) => {
              console.error("Error getting subcollection: ", error);
              setClientDataRoi([]);
            }
          );
        } else {
          // Si roiDocSnap n'existe pas, réinitialisez également clientDataRoi à un tableau vide
          setClientDataRoi([]);
        }
      } catch (e) {
        console.error("Error fetching client data: ", e);
      }
    };

    if (clientId && clientId !== prevClientIdRef.current) {
      fetchData();
    }

    prevClientIdRef.current = clientId;

    // Retournez la fonction de désinscription pour nettoyer l'effet
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [clientId]);

  useEffect(() => {}, [triggerUpdate]);

  useEffect(() => {
    let unsubscribe;

    if (clientId) {
      const roiCollectionRef = collection(db, "roi");

      unsubscribe = onSnapshot(roiCollectionRef, (snapshot) => {
        // Vérifiez si un document avec le clientId correspondant a été ajouté
        const newRoiDoc = snapshot
          .docChanges()
          .find(
            (change) => change.type === "added" && change.doc.id === clientId
          );

        if (newRoiDoc) {
          setTriggerUpdate((prevState) => !prevState);
        }
      });
    }

    // Retournez la fonction de désinscription pour nettoyer l'effet
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [clientId]);

  const [, setDocumentOfSubcollection] = useState([]);

  useEffect(() => {
    const roiDocument = doc(db, "roi", clientId);
    const subcollectionQuery = query(collection(roiDocument, "subcollection"));

    const unsubscribe = onSnapshot(subcollectionQuery, (snapshot) => {
      const newDocumentOfSubcollection = snapshot.docs.map((doc) => ({
        id: doc.id,
        data: doc.data(),
      }));

      setDocumentOfSubcollection(newDocumentOfSubcollection);
    });

    return () => {
      unsubscribe();
    };
  }, [clientId]);

  return (
    <div className="tab-container-white-mobile">
      <Modal
        open={openIntakeForm}
        onClose={handleCloseIntakeForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddIntakeForm
            clientId={props.clientId}
            {...props}
            closemodal={handleCloseIntakeForm}
          />
        </Box>
      </Modal>

      <Modal
        open={openIntakeForm2}
        onClose={handleCloseIntakeForm2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddConsentAgreementUnsupervisedActivityGood
            clientId={props.clientId}
            {...props}
            closemodal={handleCloseIntakeForm2}
          />
        </Box>
      </Modal>

      <Modal
        open={openClientIntakeAndBagSearchChecklist}
        onClose={handleCloseClientIntakeAndBagSearchChecklist}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddClientIntakeAndBagSearchChecklist
            clientId={props.clientId}
            {...props}
            closemodal={handleCloseClientIntakeAndBagSearchChecklist}
          />
        </Box>
      </Modal>

      <Modal
        open={openClientOrientationChecklist}
        onClose={handleCloseClientOrientationCheckList}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddClientOrientationChecklist
            clientId={props.clientId}
            {...props}
            closemodal={handleCloseClientOrientationCheckList}
          />
        </Box>
      </Modal>
      <Modal
        open={openAustralianSuperAnnuationForm}
        onClose={handleCloseAustralianSuperAnnuationForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddAustralianSuperannuationForm
            clientId={props.clientId}
            {...props}
            closemodal={handleCloseAustralianSuperAnnuationForm}
          />
        </Box>
      </Modal>
      <Modal
        open={openRoiForm}
        onClose={handleCloseRoiForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddReleaseOfInformationForm
            closemodal={handleCloseRoiForm}
            clientId={props.clientId}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openGeneralLiabilityForm}
        onClose={handleCloseGeneralLiabilityForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddGeneralLiabilityForm
            closemodal={handleCloseGeneralLiabilityForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openInformedConsentForm}
        onClose={handleCloseInformedConsentForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddInformedConsentForm
            clientId={props.clientId}
            closemodal={handleCloseInformedConsentForm}
          />
        </Box>
      </Modal>

      <Modal
        open={openPsychiatricServicesForm}
        onClose={handleClosePsychiatricServicesForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddPsychiatristServicesForm
            closemodal={handleClosePsychiatricServicesForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openConfidentialityPolicyForm}
        onClose={handleCloseConfidentialityPolicyForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddConfidentialityPolicy
            closemodal={handleCloseConfidentialityPolicyForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openClientRightsForm}
        onClose={handleCloseClientRightsForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddClientRights
            closemodal={handleCloseClientRightsForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openAgressionPolicyForm}
        onClose={handleCloseAgressionPolicyForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddAgressionControl
            closemodal={handleCloseAgressionPolicyForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openUploadRoi}
        onClose={handleCloseRoiForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UpdloaderRoiMobile {...props} closemodal={handleCloseUploadDoc} />
        </Box>
      </Modal>

      <Modal
        open={openDressCodePolicy}
        onClose={handleCloseDressCodePolicyForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddDressCodeForm
            closemodal={handleCloseDressCodePolicyForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openTreatmentEngagment}
        onClose={handleCloseTreatmentEngagmentForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddTreatmentEngagementForm
            closemodal={handleCloseTreatmentEngagmentForm}
            clientId={props.clientId}
            ils={props.durationOfStay}
            {...props}
          />
        </Box>
      </Modal>
      <Modal
        open={openPoliticalViews}
        onClose={handleClosePoliticalViewsForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddPoliticalViewsForm
            closemodal={handleClosePoliticalViewsForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <div className="container-main-plan-mobile-2">
        <div
          className="tab-container-title-mobile-4"
          style={{ paddingLeft: "15px" }}
        >
          Admission form
        </div>
        <div className="tab-form-container-line">
          <div className="form-line-button-column">
            <TitleIntakeMobile />
            {props.dateOfAdmission ? (
              <FormLine2Mobile
                title="Intake form"
                color="1"
                signed={!!props.dateOfAdmission}
                dateOfAdmission={formatDate(props.dateOfAdmission)}
                {...props}
              />
            ) : (
              <FormLine2Mobile
                title="No intake form signed"
                color="1"
                signed={!!props.dateOfAdmission}
              />
            )}

            {props.dateOfAdmission ? (
              " "
            ) : (
              <div
                style={{
                  width: "100%",

                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <AddButtonRoundMobile
                  handleOpen={handleOpenIntakeForm}
                  title="Add intake form"
                />
              </div>
            )}
          </div>
        </div>
        <div className="tab-form-container-line">
          <div className="form-line-button-column">
            <TitleMobile />
            <FormLineSuperAnnuationMobile
              title="Australian Superannuation"
              color="2"
              signed={props.australianSuperannuationOk}
              date={formatDate(props.australianSuperannuationDateSigned)}
              {...props}
            />
            {props.australianSuperannuationOk ? (
              ""
            ) : (
              <div
                style={{
                  width: "100%",

                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <AddButtonRoundMobile
                  handleOpen={handleOpenAustralianSuperAnnuationForm}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="container-main-plan-mobile-2"
        style={{ marginTop: "10px" }}
      >
        <div
          className="tab-container-title-mobile-4"
          style={{ paddingLeft: "15px" }}
        >
          Intake forms
        </div>
        {/* <div className="tab-form-container-line">
          <div className="form-line-button-column">
            <TitleIntakeMobile />
            <FormLineConsAndAgreemOutsideActivityMobile
              title="Consent and Agreement Form for Unsupervised Off-Site Activities"
              color="2"
              signed={props.ConsentAgreementUnsupervisedActivitiesOk}
              date={formatDate(
                props.ConsentAgreementUnsupervisedActivitiesOkSigned
              )}
              {...props}
            />
            {props.ConsentAgreementUnsupervisedActivitiesOk ? (
              ""
            ) : (
              <AddButtonRoundMobile handleOpen={handleOpenIntakeForm2} />
            )}
          </div>
        </div> */}

        <div className="tab-form-container-line">
          <div className="form-line-button-column">
            <TitleMobile />
            <FormLineIntakeAndBagSearchCheclistMobile
              title="Client intake and bag search checklist"
              color="2"
              signed={props.clientIntakeAndBagSearchOk}
              date={formatDate(props.clientIntakeAndBagSearchDateSigned)}
              {...props}
            />
            {props.clientIntakeAndBagSearchOk ? (
              ""
            ) : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <AddButtonRoundMobile
                  handleOpen={handleOpenClientIntakeAndBagSearchChecklist}
                />
              </div>
            )}
          </div>
        </div>

        <div className="tab-form-container-line">
          <div className="form-line-button-column">
            <TitleMobile />
            <FormLineClientOrientationChecklistMobile
              title="Client Orientation Checklist"
              color="2"
              signed={props.clientOrientationCheckListOk}
              date={formatDate(props.clientOrientationCheckListDateSigned)}
              {...props}
            />
            {props.clientOrientationCheckListOk ? (
              ""
            ) : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <AddButtonRoundMobile
                  handleOpen={handleOpenClientOrientationCheckList}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container-main-plan-mobile">
        <div
          className="tab-container-title-mobile-4"
          style={{ paddingLeft: "15px" }}
        >
          Mandatory forms
        </div>

        {props.dateOfAdmission ? (
          <>
            <div className="tab-form-container-line">
              <div className="form-line-button-column">
                <TitleMobile />
                <FormLine3Mobile
                  title="General liability release"
                  color="2"
                  signed={props.GeneralLiabilityOk}
                  date={formatDate(props.GeneralLiabilityDateSigned)}
                  {...props}
                />
                {props.GeneralLiabilityOk ? (
                  ""
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignContent: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                      marginBottom: "20px",
                    }}
                  >
                    <AddButtonRoundMobile
                      handleOpen={handleOpenGeneralLiabilityForm}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="form-line-button-column">
              <FormLineICMobile
                title="Informed consent"
                color="1"
                signed={props.InformedConsentOk}
                date={formatDate(props.InformedConsentDateSigned)}
                {...props}
              />

              {props.InformedConsentOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenInformedConsentForm}
                  />
                </div>
              )}
            </div>

            <div className="form-line-button-column">
              <FormLinePSCMobile
                title="Psychiatric services and detox costs"
                color="2"
                signed={props.PsychiatristServicesOk}
                date={formatDate(props.PsychiatristServicesDateSigned)}
                {...props}
              />
              {props.PsychiatristServicesOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",

                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenPsychiatricServicesForm}
                  />
                </div>
              )}
            </div>

            <div className="form-line-button-column">
              <FormLineCPMobile
                title="Confidentiality policy "
                color="1"
                signed={props.ConfidentialityPolicysOk}
                date={formatDate(props.ConfidentialityPolicyDateSigned)}
                {...props}
              />

              {props.ConfidentialityPolicysOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenConfidentialityPolicyForm}
                  />
                </div>
              )}
            </div>

            <div className="form-line-button-column">
              <FormLineCRMobile
                signed={props.ClientRightsOk}
                date={formatDate(props.ClientRightsDateSigned)}
                {...props}
                title="Client rights"
                color="2"
              />
              {props.ClientRightsOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenClientRightsForm}
                  />
                </div>
              )}
            </div>

            <div className="form-line-button-column">
              <FormLineACPMobile
                title="Agression control policy"
                color="1"
                signed={props.AggressionControlPolicyOk}
                date={formatDate(props.AggressionControlPolicyDateSigned)}
                {...props}
              />
              {props.AggressionControlPolicyOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenAgressionPolicyForm}
                  />
                </div>
              )}
            </div>

            <div className="form-line-button-column">
              <FormLineDressCodeMobile
                title="Dress code policy"
                color="1"
                signed={props.dressCodePolicyOk}
                date={formatDate(props.DressCodePolicyDateSigned)}
                {...props}
              />
              {props.dressCodePolicyOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenDressCodePolicyForm}
                  />
                </div>
              )}
            </div>

            <div className="form-line-button-column">
              <FormLineTreatmentEngagementMobile
                title="Treatment engagement Policy"
                color="1"
                signed={props.treatmentEngagementPolicyOk}
                date={formatDate(props.treatmentEngagementPolicyDateSigned)}
                {...props}
              />
              {props.treatmentEngagementPolicyOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenTreatmentEngagmentForm}
                  />
                </div>
              )}
            </div>
            <div className="form-line-button-column">
              <FormLinePoliticalViewsMobile
                title="Political Views and Discrimination Policy"
                color="1"
                signed={props.politicalViewsFormOk}
                date={formatDate(props.politicalViewsDateSigned)}
                {...props}
              />
              {props.politicalViewsFormOk ? (
                ""
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <AddButtonRoundMobile
                    handleOpen={handleOpenPoliticalViewsForm}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="error-discharge-message-mobile">
            Unable to add Mandatory forms if the client is not admitted.
          </div>
        )}
      </div>

      <div className="container-main-plan-mobile">
        <div
          className="tab-container-title-mobile-4"
          style={{ paddingLeft: "15px" }}
        >
          Authorization for release of confidential information
        </div>

        {props.dateOfAdmission ? (
          <div>
            <div className="form-line-button-title-column">
              <FormLineTitleMobile
                title="Authorization for Release of Confidential Information"
                color="2"
                {...props}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                <AddButtonRoundMobile handleOpen={handleOpenRoiForm} />
              </div>

              <div className="roi-container-mobile">
                {clientDataRoi && clientDataRoi.length > 0
                  ? // <TitleMediumRoi /
                    ""
                  : ""}

                {clientDataRoi.map((item, index) => (
                  <FormLineRoiMobile
                    key={index}
                    title={item.companyIndividualName}
                    relationship={item.relationship}
                    signedOn={item.signedOn}
                    revoked={item.revoked}
                    {...item}
                    firstName={props.firstName}
                    lastName={props.lastName}
                    clientId={clientId}
                    subcollectionDocumentId={item.id}
                  />
                ))}
              </div>
            </div>

            <div
              style={{
                width: "95%",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                justifyItems: "center",
              }}
            >
              <UploaderAraEncapsulated {...props} />
            </div>
          </div>
        ) : (
          <div className="error-discharge-message-mobile">
            Unable to add R.O.I. form if the client is not admitted.
          </div>
        )}
      </div>

      <br />
      <br />
    </div>
  );
}

export default FormsMobile;
